import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import reactLogo from '../images/skills/react.svg';
import AzureLogo from '../images/skills/azure.svg'
import CypressLogo from '../images/skills/cypress.svg';
import GithubLogo from '../images/skills/github.svg';
import JsLogo from '../images/skills/javascript.svg';
import MaterialUILogo from '../images/skills/material-ui.svg';
import NodeLogo from '../images/skills/node.svg';
import mysqlLogo from '../images/skills/mysql.svg';
import YouTube from '@mui/icons-material/YouTube';
import GitHubIcon from '@mui/icons-material/GitHub';
import Avatar from '@mui/material/Avatar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Fade  from '@mui/material/Fade';

const items = [
  {
    stacks: [
      reactLogo,
      JsLogo,
      NodeLogo,
      MaterialUILogo,
      AzureLogo,
      GithubLogo,
      ],
    title: 'BrisQuest',
    description: 'Voice to Text Recognition, Google Maps, ABV Calculator in Top-right Menu and Node backend deployed to serverless Azure Functions. Search venues in Brisbane with options of select venue locations on Map or list, display suggested nearby transport + events of selected venue.',
    stack: 'ReactJS + Node Express + Material UI + Google Maps API + Azure Functions + GitHub Actions & Pages',
    video: require('../videos/BrisQuest.mp4'),
    repoIcon: <GitHubIcon/>,
    videoIcon: <YouTube/>,
    webURL: 'https://ewu0001.github.io/BrisQuest/',
    youtubeURL: 'https://youtu.be/JNUUApKVecE',
    repoURL: 'https://github.com/EWU0001/',
  },
  {
    stacks: [
      reactLogo,
      JsLogo,
      CypressLogo,
      GithubLogo,
    ],
    title: 'BrewQuery',
    description:
    'Front end project using ReactJS and openBrewery API, allow users Search breweries in the US. Features: React Routing, Pagination, Sort & Filter, location on Map view, E2E testing for login page',
    stack: 'ReactJS + React Boostrap + Cypress E2E + GitHub Actions & Pages',
    video: require('../videos/reactfrontenddemo_trimmed.mp4'),
    repoIcon: <GitHubIcon/>,
    videoIcon: <YouTube/>,
    webURL: 'https://ewu0001.github.io/BrewQueryApp/',
    youtubeURL: 'https://youtu.be/anMq3WrdEEw',
    repoURL: 'https://github.com/EWU0001/BrewQueryApp',
  },
  {
    stacks:[
      reactLogo,
      JsLogo,
      NodeLogo,
      mysqlLogo,
    ],
    title: 'BrewQuery Mobile',
    description:
    'Full Stack mobile application, allows users Search breweries in the US, create user account and save to favourite list. Features: JWT Auth, user info save to database & local storage.',
    stack: 'React Native + Node Express + JWT + MySQL ',
    video: require('../videos/reactnativedemotrimmed.mp4'),
    repoIcon: <GitHubIcon/>,
    videoIcon: <YouTube/>,
    webURL: 'https://github.com/EWU0001/',
    youtubeURL: 'https://youtu.be/m8RI9XpIBEU?si=Ho8PtxEtXUEgndy4',
    repoURL: 'https://github.com/EWU0001/',
  },
];

export default function Projects() {
  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);
  const [open, setOpen] = React.useState(false);

  const handleItemClick = (index: number) => {
    setSelectedItemIndex(index);
  };
  const selectedFeature = items[selectedItemIndex];
  const handleClickOpen = () => {
    setOpen(true);
  }
  const handleClickClose = () => {
    setOpen(false);
  }

  return (
    <Container id="projects" sx={{ py: { xs: 8, sm: 12 },width:'100%' }}>
        <Grid item xs={12} md={6}>
          {/* header */}
          <div style={{textAlign:'center'}}>
            <Typography component="h2" variant="h4" color="text.primary">
              PROJECTS
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: { xs: 2, sm: 4 } }}
            >
              Here is a list of personal projects.
            </Typography>
          </div>
          {/* small screen */}
          <Grid container gap={1} sx={{ display: { xs: 'auto', sm: 'none' } }}>
            {items.map(({ title }, index) => (
              <Chip
                key={index}
                label={title}
                onClick={() => handleItemClick(index)}
                sx={{
                  borderColor: (theme) => {
                    if (theme.palette.mode === 'light') {
                      return selectedItemIndex === index ? 'primary.light' : '';
                    }
                    return selectedItemIndex === index ? 'primary.light' : '';
                  },
                  background: (theme) => {
                    if (theme.palette.mode === 'light') {
                      return selectedItemIndex === index ? 'none' : '';
                    }
                    return selectedItemIndex === index ? 'none' : '';
                  },
                  backgroundColor: selectedItemIndex === index ? 'primary.main' : '',
                  '& .MuiChip-label': {
                    color: selectedItemIndex === index ? '#fff' : '',
                  },
                }}
              />
            ))}
          </Grid>
          <Box
            component={Card}
            variant="outlined"
            sx={{
              display: { xs: 'auto', sm: 'none' },
              mt: 4,
            }}
          >
            <Box
              sx={{
                overflow: 'hidden',
                width: '100%',
              }}
            />
            <video
                src={selectedFeature.video}
                autoPlay
                controls
                style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                }}
            />
            <Box sx={{ px: 2, pb: 2 }}>
              <Typography color="text.primary" variant="body2" fontWeight="bold">
                {selectedFeature.title}
              </Typography>
              <Typography color="text.secondary" variant="body2" sx={{ my: 1 }}>
                {selectedFeature.description}
              </Typography>
              <Typography color="text.secondary" variant="body2" sx={{ my: 1 }}>
                Stack: {selectedFeature.stack}
              </Typography>
              <Link
                color="primary"
                variant="body2"
                fontWeight="bold"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  '& > svg': { transition: '0.2s' },
                  '&:hover > svg': { transform: 'translateX(2px)' },
                }}
                onClick={() => { window.open(selectedFeature.webURL,'_blank')}}
              >
                <span>Web Link</span>
                <ChevronRightRoundedIcon
                  fontSize="small"
                  sx={{ mt: '1px', ml: '2px' }}
                />
              </Link>
              <Tooltip title="GitHub">
              <button style={{borderRadius:'30%', color:'grey', marginRight:5, background:'none', border:'none', cursor:'pointer'}} onClick={()=>{window.open(selectedFeature.repoURL)}}>{selectedFeature.repoIcon}</button>
              </Tooltip>
              <Tooltip title="Video">
              <button style={{borderRadius:'30%', color:'red', background:'none', border:'none', cursor:'pointer'}} onClick={()=>{window.open(selectedFeature.youtubeURL)}}>{selectedFeature.videoIcon}</button>
              </Tooltip>
            </Box>
          </Box>
          {/* large screen */}
          <Grid container sx={{ display: { xs: 'none', sm: 'flex' }, flexWrap:'wrap', justifyContent:'center', gap: 15 }}>
          {items.map((item, index) => (
            <Grid item sm={5} lg={3} >
              <Card
                key={index}
                variant="outlined"
                component={Button}
                onClick={() => {
                    handleClickOpen()
                    handleItemClick(index)
                  }
                }
                sx={{
                  p: 1,
                  height: '390px',
                  width: '360px',
                  background: 'none',
                  backgroundColor:
                    selectedItemIndex === index ? 'action.selected' : undefined,
                  borderColor: (theme) => {
                    if (theme.palette.mode === 'light') {
                      return selectedItemIndex === index
                        ? 'primary.light'
                        : 'grey.200';
                    }
                    return selectedItemIndex === index ? 'primary.dark' : 'grey.800';
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    textAlign: 'left',
                    flexDirection: 'column',
                  }}
                >
                  <Box
                    sx={{
                      color: (theme) => {
                        if (theme.palette.mode === 'light') {
                          return selectedItemIndex === index
                            ? 'primary.main'
                            : 'grey.300';
                        }
                        return selectedItemIndex === index
                          ? 'primary.main'
                          : 'grey.700';
                      },
                    }}
                  >
                  </Box>
                  <video
                    src={item.video}
                    autoPlay={true}
                    loop
                    controls
                    style={{
                        width:'100%',
                        height: 'auto',
                    }}
                  />
                  <Box sx={{ textTransform: 'none', mt:1, padding:1 }}>
                    <Typography
                      color="text.primary"
                      variant="body2"
                      fontWeight="bold"
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      color="text.secondary"
                      variant="body2"
                      sx={{ my: 2 }}
                    >
                      Stack: {item.stack}
                    </Typography>
                    <Link
                      color="primary"
                      variant="body2"
                      fontWeight="bold"
                      sx={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        '& > svg': { transition: '0.2s' },
                        '&:hover > svg': { transform: 'translateX(2px)' },
                      }}
                      onClick={() => { window.open(item.webURL,'_blank')
                      }}
                    >
                      <span>Web Link</span>
                      <ChevronRightRoundedIcon
                        fontSize="small"
                        sx={{ mt: '1px', ml: '2px' }}
                      />
                    </Link>
                    <Tooltip title="GitHub">
                    <button style={{borderRadius:'30%', color:'grey', marginRight:5, background:'none', border:'none', cursor:'pointer'}} onClick={()=>{window.open(item.repoURL)}}>{item.repoIcon}</button>
                    </Tooltip>
                    <Tooltip title="Video">
                    <button style={{borderRadius:'30%', color:'red', background:'none', border:'none', cursor:'pointer'}} onClick={()=>{window.open(item.youtubeURL)}}>{item.videoIcon}</button>
                    </Tooltip>
                  </Box>
                </Box>
              </Card>
              </Grid>
            ))}
            </Grid>
        </Grid>
        <Dialog
          open={open}
          onClose={handleClickClose}
          aria-describedby='dialog'
          TransitionComponent={Fade}
          transitionDuration={800}          
        >
          <DialogContent
            sx={{
              padding: '1px 1px',
              backgroundColor:'black',
                color: (theme) => {
                  if (theme.palette.mode === 'light') {
                    return 'grey.300';
                  }
                  return 'grey.400';
                },
            }}
          >
            <video
                src={selectedFeature.video}
                autoPlay
                controls
                style={{
                  width:'100%',
                  height: 'auto',
                }}
            />
            <div style={{ display:'flex', flexDirection:'row', justifyContent:'center' }}>
            {selectedFeature.stacks.map((stack,stackIndex)=>(
              <Avatar sx={{width:'30px',height:'30px', margin:'10px'}} src={stack}/>
            ))}
            </div>
            <Typography
                      variant="body2"
                      sx={{ my: 2, mx:2 }}
                    >
              Features: {selectedFeature.description}
                    </Typography>
          </DialogContent>
        </Dialog>
    </Container>
  );
}